export default {
  title: 'Pay-Period',
  home: 'Home',
  company: 'Company',
  'delete-row-modal': {
    title: 'Pay-Period',
    content: 'Would you like to delete this seletced item?',
    button: {
      accept: 'YES',
      cancel: 'NO'
    }
  },
  form: {
    startPeriod: {
      label: 'Start date',
      placeholder: 'Start date'
    },
    endPeriod: {
      label: 'End date',
      placeholder: 'End date'
    }
  },
  'company-table': require('./CompanyTable.js').default
}
